// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Експертні ради» (Expert councils, ключ `xcouncil`, група `experts`). */
export const expertCouncilsManifest: IModuleManifest = {
  key: 'xcouncil',
  group: 'experts',
  slug: 'expert-councils',
  prefix: 'XCL',
  name: { en: 'Expert councils', uk: 'Експертні ради' },
  entities: [
    { key: 'xcouncil', slug: 'xcouncil', name: { en: 'Councils', uk: 'Ради' }, main: true },
    { key: 'xcmeet', slug: 'xcmeet', name: { en: 'Council meetings', uk: 'Засідання рад' }, main: false },
  ],
  loadState: () => import('./state/expertCouncilsSlice').then((m) => m.expertCouncilsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
